document.addEventListener('DOMContentLoaded', function() {
    const madeToOrderModal = () => {
        const openButtons = document.querySelectorAll('.made-to-order-btn');
        const modals = document.querySelectorAll('.made-to-order-modal');

        if (!openButtons || !modals) return;

        openButtons.forEach(btn => {
            btn.addEventListener('click', (evt) => {
                if (!btn.classList.contains('made-to-order-btn')) return;
                const title = btn.getAttribute('data-product-title');
                const modal = Array.from(modals).find(m => m.dataset.productTitle === title);
                evt.preventDefault();
                evt.stopPropagation();
                if (modal) {
                    modal.classList.add('active');
                    // Clear previous feedback on open
                    const feedback = modal.querySelector('.modal-feedback');
                    if (feedback) feedback.innerHTML = '';
                }
            });
        });

        modals.forEach(modal => {
            modal.addEventListener('click', e => {
                const isClose = e.target.classList.contains('modal-close') || e.target.classList.contains('modal-backdrop');
                if (isClose) modal.classList.remove('active');
            });
        });

        // ✅ Show modal again if contact_posted=true is in URL
        const urlParams = new URLSearchParams(window.location.search);
        const posted = urlParams.get('contact_posted');
        const anchor = window.location.hash;

        if (posted === 'true' && anchor === '#contact_form') {
            const successModal = document.querySelector('.made-to-order-modal[data-show-on-success="true"]');
            if (successModal) {
                successModal.classList.add('active');
                const message = successModal.querySelector('.success-message');
                if (message) message.style.display = 'block';

                // Add a class to the modal to hide form fields after submission
                successModal.classList.add('has-submitted');

                // After showing the modal, remove the query/hash from the URL
                const cleanUrl = window.location.origin + window.location.pathname;
                window.history.replaceState({}, document.title, cleanUrl);
            }
        }
    }

    madeToOrderModal();

});
